module.exports = __webpack_public_path__ + "static/media/supportMockup.ec51b4aa.png";